export const CHAT_URL = "/chat";

/** Chat workspace URL; optional thread opens the reply panel. */
export function buildChatUrl(conversationId?: number | null, threadId?: number | null): string {
  if (!conversationId) return CHAT_URL;
  return threadId
    ? `${CHAT_URL}/${conversationId}/${threadId}`
    : `${CHAT_URL}/${conversationId}`;
}
